import LeadsToCloseLoader from "../leads-to-close-loader/LeadsToCloseLoader";


const LeadsToClose = () => {

  return (
    <LeadsToCloseLoader 
      title={"Briefs signés à clôturer"}
        showMenu={true}
        limit={null}
        paginateResults={true} 
        height={'80%'}
        />
  );


}

export default LeadsToClose;
